import styled from "@emotion/styled";

import { color } from "metabase/lib/colors";
import { Icon } from "metabase/ui";

export const ClearIcon = styled(Icon)`
  color: ${color("brand")};
`;
